import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    index:0,
    currentExercice: {},
    reponsesList:[
    ],
    tutorielsList:[
    ],
    isGameCompleted:false,
    resultat:{},
}
const challengeZoneSlice = createSlice({
    name:'challengeZone',
    initialState,
    reducers:{
        setCurrentExercice:(state,{payload})=>{
            state.currentExercice = payload
            state.index = state.index + 5
        },
        setReponsesList:(state,{payload})=>{
            state.reponsesList = payload;
        },
        setTutorielsList:(state,{payload})=>{
            state.tutorielsList = payload
        },
        setIsGameChallengeCompleted:(state,{payload})=>{
            state.isGameCompleted = true
            state.resultat = payload
        },
        resetChallengeGame:(state,{payload})=>{
            state.isGameCompleted = false
            state.reponsesList = []
            state.currentExercice = {}
            state.index = 0
            state.resultat = {}
        },
    }
})

export const { setCurrentExercice,setReponsesList,setIsGameChallengeCompleted ,resetChallengeGame,setCurrentStep} = challengeZoneSlice.actions
export default challengeZoneSlice.reducer